(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-catalog"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tt-catalog-refine')) {
  customElements.define('tt-catalog-refine', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const drawer = this.querySelector('.tt-catalog__drawer');
      const opener = this.querySelector('[data-tt-open]');
      const close = () => { if (drawer?.open) drawer.close(); };
      opener?.addEventListener('click', () => {
        drawer.showModal();
        opener.setAttribute('aria-expanded', 'true');
      }, options);
      this.querySelectorAll('[data-tt-close]').forEach(button => button.addEventListener('click', close, options));
      drawer?.addEventListener('close', () => opener?.setAttribute('aria-expanded', 'false'), options);
      drawer?.addEventListener('click', event => {
        if (event.target !== drawer) return;
        const bounds = drawer.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      }, options);
      matchMedia('(min-width: 960px)').addEventListener('change', event => { if (event.matches) close(); }, options);
      const popovers = [...this.querySelectorAll('.tt-catalog__desktop-filters details')];
      popovers.forEach(popover => popover.addEventListener('toggle', () => {
        if (popover.open) popovers.forEach(other => { if (other !== popover) other.open = false; });
      }, options));
      document.addEventListener('click', event => { popovers.forEach(popover => { if (!popover.contains(event.target)) popover.open = false; }); }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        popovers.forEach(popover => { if (popover.open) { popover.open = false; popover.querySelector('summary')?.focus(); } });
      }, options);
      const sort = this.querySelector('[data-tt-sort]');
      const applySort = () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      };
      sort?.addEventListener('change', applySort, options);
      sort?.form?.addEventListener('submit', event => { event.preventDefault(); applySort(); }, options);
      this.setAttribute('data-ready', '');
    }
    disconnectedCallback() { this.querySelector('.tt-catalog__drawer')?.close(); this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-directory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tt-shop-carousel')) {
  customElements.define('tt-shop-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('[data-carousel-track]');
      const previous = this.querySelector('[data-carousel-prev]');
      const next = this.querySelector('[data-carousel-next]');
      if (!track || !previous || !next) return;
      this.setAttribute('data-enhanced', '');
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = direction => {
        const card = track.querySelector('.tt-shop-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const count = Math.max(1, Math.floor(track.clientWidth / step));
        track.scrollBy({ left: direction * step * count, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      requestAnimationFrame(update);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-giftcard-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tt-gift-product')){customElements.define('tt-gift-product',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const radios=this.querySelectorAll('input[name="id"]');const update=()=>{const active=this.querySelector('input[name="id"]:checked');if(!active)return;this.querySelectorAll('[data-gift-price],[data-gift-amount]').forEach(el=>el.textContent=active.dataset.price);const url=new URL(window.location.href);if(url.pathname.includes('/products/')){url.searchParams.set('variant',active.value);history.replaceState(null,'',url.toString());}};radios.forEach(input=>input.addEventListener('change',update));const recipient=this.querySelector('.tt-gift__recipient');const toggle=this.querySelector('[data-recipient-toggle]');const fields=this.querySelector('[data-recipient-fields]');const email=this.querySelector('[data-recipient-email]');if(recipient&&toggle&&fields&&email){recipient.hidden=false;const sync=()=>{fields.hidden=!toggle.checked;fields.disabled=!toggle.checked;email.required=toggle.checked;toggle.setAttribute('aria-expanded',String(toggle.checked));};toggle.addEventListener('change',sync);sync();}update();}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-header"]) return;
  try {
    
if (!customElements.get('tt-site-header')) {
  customElements.define('tt-site-header', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const toggle = this.querySelector('.tt-mobile-toggle');
      const drawer = this.querySelector('.tt-drawer');
      if (!toggle || !drawer) return;
      const close = () => { if (drawer.open) drawer.close(); };
      toggle.addEventListener('click', () => {
        if (drawer.open) close();
        else { drawer.showModal(); toggle.setAttribute('aria-expanded', 'true'); }
      }, options);
      drawer.querySelector('.tt-drawer__close').addEventListener('click', close, options);
      drawer.addEventListener('close', () => { toggle.setAttribute('aria-expanded', 'false'); }, options);
      drawer.addEventListener('click', event => {
        if (event.target.closest('a')) close();
        if (event.target === drawer) {
          const bounds = drawer.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
        }
      }, options);
      const desktop = matchMedia('(min-width: 761px)');
      desktop.addEventListener('change', event => { if (event.matches) close(); }, options);
    }
    disconnectedCallback() { this.querySelector('.tt-drawer')?.close(); this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
